import type { Item, SelectedItem } from '../SelectItems.types'
import type { SelectItemProps } from '../components/SelectItem/SelectItem'
import { isOfferItemType } from './isOfferItemType'

export const getSelectItemInitialValues = (
  item: Item,
  selectedItems: SelectedItem[],
): SelectItemProps['initialValues'] => {
  let checked = false
  let quantity = '1'

  if (!isOfferItemType(item)) {
    const selectedItem = selectedItems.find(
      (selectedItem) => selectedItem.variantId === item.variantId,
    )

    if (selectedItem) {
      checked = true
      quantity = selectedItem.quantity
    }
  }

  return {
    checked,
    quantity,
  }
}
